import { render, staticRenderFns } from "./SampleFooter.vue?vue&type=template&id=0307539d&"
import script from "./SampleFooter.vue?vue&type=script&lang=js&"
export * from "./SampleFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports